var mobileMenu = {
    init: function() {
        var $mobileNavbar = jQuery( '#mobileNavbar' ),
            $hamburger = jQuery( '#menuToggle'),
            $mobileMenu = jQuery( '.mobile-menu' ),
            $submenuToggle = jQuery( '.submenu-toggle' ),
            $submenuParent = jQuery( 'span.mobile-menu__link' ),
            $langSwitcher = $mobileNavbar.find('.language-switcher');

        var navigation = document.querySelector( '.mobile-menu__container' );

        $hamburger.on( 'click', function() {
            jQuery(this).toggleClass('clicked')
            $mobileMenu.toggleClass( 'mobile-menu--opened' );
            jQuery( document.body ).toggleClass( 'navigation-opened' );
        } );

        $submenuToggle.on( 'click', function() {
            jQuery(this).toggleClass('clicked')
            jQuery(this).next('.mobile-menu__submenu').slideToggle();
        } );

        $submenuParent.on( 'click', function() {
            jQuery(this).next().toggleClass('clicked')
            jQuery(this).parent().find('.mobile-menu__submenu').slideToggle();
        } );

        $langSwitcher.find('.current-lang').on( 'click', function(e) {
            e.preventDefault();
            jQuery(this).next('.language-switcher__submenu').toggle();
        } );
    }
}

export {
    mobileMenu
};
